function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance. In order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.to-string.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { absoluteUrl } from "./absolute_url";
import { Swiper } from "./swiper_ex";
import { Navigation, Pagination } from "swiper";
import EventTarget from "ol/events/Target";
import page from "../legacy/page";
import bsn from "../legacy/bootstrap-native";
import { MaplatApp as Core, createElement } from "@maplat/core";
import ContextMenu from "./contextmenu";
import { Geolocation } from "./geolocation";
import iziToast from "../legacy/iziToast";
import QRCode from "../legacy/qrcode";
import { point, polygon } from "@turf/helpers";
import booleanPointInPolygon from "@turf/boolean-point-in-polygon";
import sprintf from "../legacy/sprintf";
import { META_KEYS } from "@maplat/core/lib/source/mixin";
import { Copyright, CompassRotate, SetGPS, GoHome, Maplat, Border, HideMarker, SliderNew, Share, Zoom, setControlSettings } from "./maplat_control";
import { asArray } from "ol/color";
import { HistMap } from "@maplat/core/lib/source/histmap";
import { TmsMap } from "@maplat/core/lib/source/tmsmap";
import { NowMap } from "@maplat/core/lib/source/nowmap";
import { GoogleMap } from "@maplat/core/lib/source/googlemap";
import Weiwudi from "weiwudi";
import { normalizeArg } from "./function";
import pointer from "./pointer_images";
Swiper.use([Navigation, Pagination]);

// Maplat UI Class
export var MaplatUi = /*#__PURE__*/function (_EventTarget) {
  _inherits(MaplatUi, _EventTarget);
  var _super = _createSuper(MaplatUi);
  function MaplatUi(appOption) {
    var _this;
    _classCallCheck(this, MaplatUi);
    _this = _super.call(this);
    appOption = normalizeArg(appOption);
    if (appOption.control) {
      setControlSettings(appOption.control);
    }
    var ui = _assertThisInitialized(_this);
    ui.html_id_seed = "".concat(Math.floor(Math.random() * 9000) + 1000);
    if (appOption.stateUrl) {
      page(function (ctx, _next) {
        var pathes = ctx.canonicalPath.split("#!");
        var path = pathes.length > 1 ? pathes[1] : pathes[0];
        pathes = path.split("?");
        path = pathes[0];
        if (path === ui.pathThatSet) {
          delete ui.pathThatSet;
          return;
        }
        var restore = {
          transparency: 0,
          position: {
            rotation: 0
          }
        };
        path.split("/").map(function (state) {
          var line = state.split(":");
          switch (line[0]) {
            case "s":
              restore.mapID = line[1];
              break;
            case "b":
              restore.backgroundID = line[1];
              break;
            case "t":
              restore.transparency = parseFloat(line[1]);
              break;
            case "r":
              restore.position.rotation = parseFloat(line[1]);
              break;
            case "z":
              restore.position.zoom = parseFloat(line[1]);
              break;
            case "x":
            case "y":
              restore.position[line[0]] = parseFloat(line[1]);
              break;
            case "sb":
              restore.showBorder = !!parseInt(line[1]);
              break;
            case "hm":
              restore.hideMarker = !!parseInt(line[1]);
              break;
            case "hl":
              restore.hideLayer = line[1];
              break;
            case "c":
              if (ui.core) {
                var modalElm = ui.core.mapDivDocument.querySelector(".modalBase");
                var modal = new bsn.Modal(modalElm, {
                  root: ui.core.mapDivDocument
                });
                modal.hide();
              }
          }
        });
        if (!ui.core) {
          if (restore.mapID) {
            appOption.restore = restore;
          }
          ui.initializer(appOption);
        } else if (restore.mapID) {
          ui.core.waitReady.then(function () {
            ui.core.changeMap(restore.mapID, restore);
          });
        }
      });
      page({
        hashbang: true
      });
      page();
      ui.waitReady = new Promise(function (resolve, _reject) {
        ui.waitReadyBridge = resolve;
      });
    } else {
      ui.initializer(appOption);
    }
    return _this;
  }
  _createClass(MaplatUi, [{
    key: "initializer",
    value: function () {
      var _initializer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(appOption) {
        var ui, lastEpoch, currentTime, enableSplash, restoreTransparency, enableOutOfMap, enablePoiHtmlNoScroll, pwaManifest, pwaWorker, pwaScope, newElems, i, prevDefs, _i, target, _i2, shareBtns, _i3, shareBtn, head, xhr, showContextMenu;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              showContextMenu = function _showContextMenu(menues) {
                ui.contextMenu.clear();
                var mouseOnTasks = [];
                menues.forEach(function (menu) {
                  ui.contextMenu.push(menu);
                  if (menu.mouseOnTask) mouseOnTasks.push([menu.mouseOnTask, menu.mouseOutTask]);
                });
                var coordinate = ui.core.lastClickEvent.coordinate;
                var pixel = ui.core.lastClickEvent.pixel;
                if (ui.contextMenu.disabled) return;
                var openHandler = function openHandler() {
                  ui.contextMenu.removeEventListener("open", openHandler);
                  if (mouseOnTasks.length > 0) {
                    var lis = _toConsumableArray(ui.core.mapDivDocument.querySelectorAll(".ol-ctx-menu-container ul li"));
                    var events = lis.map(function (li, i) {
                      var tasks = mouseOnTasks[i];
                      li.addEventListener("mouseover", tasks[0]);
                      li.addEventListener("mouseout", tasks[1]);
                      return [li, tasks[0], tasks[1]];
                    });
                    var closeHandler = function closeHandler() {
                      ui.contextMenu.removeEventListener("close", closeHandler);
                      events.forEach(function (event) {
                        event[0].removeEventListener("mouseover", event[1]);
                        event[0].removeEventListener("mouseout", event[2]);
                      });
                    };
                    ui.contextMenu.on("close", closeHandler);
                  }
                };
                ui.contextMenu.on("open", openHandler);
                ui.contextMenu.Internal.openMenu(pixel, coordinate);

                //one-time fire
                ui.core.mapObject.getViewport().addEventListener("pointerdown", {
                  handleEvent: function handleEvent(e) {
                    if (ui.contextMenu.Internal.opened) {
                      ui.contextMenu.Internal.closeMenu();
                      e.stopPropagation();
                      ui.core.mapObject.getViewport().removeEventListener(e.type, this, false);
                    }
                  }
                }, false);
              };
              ui = this;
              appOption.translateUI = true;
              ui.core = new Core(appOption);
              if (appOption.icon) {
                pointer["defaultpin.png"] = appOption.icon;
              }
              if (appOption.restore) {
                ui.setShowBorder(appOption.restore.showBorder || false);
                if (appOption.restore.hideMarker) {
                  ui.core.mapDivDocument.classList.add("hide-marker");
                }
              } else if (appOption.restoreSession) {
                lastEpoch = parseInt(localStorage.getItem("epoch") || 0); // eslint-disable-line no-undef
                currentTime = Math.floor(new Date().getTime() / 1000);
                if (lastEpoch && currentTime - lastEpoch < 3600) {
                  ui.setShowBorder(!!parseInt(localStorage.getItem("showBorder") || "0")); // eslint-disable-line no-undef
                }
                if (ui.core.initialRestore.hideMarker) {
                  ui.core.mapDivDocument.classList.add("hide-marker");
                }
              } else {
                ui.setShowBorder(false);
              }
              enableSplash = !ui.core.initialRestore.mapID;
              restoreTransparency = ui.core.initialRestore.transparency;
              enableOutOfMap = !appOption.presentationMode;
              enablePoiHtmlNoScroll = appOption.enablePoiHtmlNoScroll;
              if (appOption.enableShare) {
                ui.core.mapDivDocument.classList.add("enable_share");
                ui.enableShare = true;
              }
              if (appOption.enableHideMarker) {
                ui.core.mapDivDocument.classList.add("enable_hide_marker");
                ui.enableHideMarker = true;
              }
              if (appOption.enableBorder) {
                ui.core.mapDivDocument.classList.add("enable_border");
                ui.enableBorder = true;
              }
              if (appOption.disableNoimage) {
                ui.disableNoimage = true;
              }
              if (appOption.stateUrl) {
                ui.core.mapDivDocument.classList.add("state_url");
              }
              if (appOption.alwaysGpsOn) {
                ui.alwaysGpsOn = true;
              }
              if (ui.core.enableCache) {
                ui.core.mapDivDocument.classList.add("enable_cache");
              }
              if ("ontouchstart" in window) {
                // eslint-disable-line no-undef
                ui.core.mapDivDocument.classList.add("ol-touch");
                ui.isTouch = true;
              }
              if (appOption.mobileIF) {
                appOption.debug = true;
              }
              if (appOption.appEnvelope) {
                ui.appEnvelope = true;
              }
              pwaManifest = appOption.pwaManifest;
              pwaWorker = appOption.pwaWorker;
              pwaScope = appOption.pwaScope; // Add UI HTML Element
              newElems = createElement("<d c=\"ol-control map-title\"><s></s></d> <d c=\"swiper-container ol-control base-swiper prevent-default-ui\"> <d c=\"swiper-wrapper\"></d> <d c=\"swiper-button-next base-next swiper-button-white\"></d> <d c=\"swiper-button-prev base-prev swiper-button-white\"></d> </d> <d c=\"swiper-container ol-control overlay-swiper prevent-default-ui\"> <d c=\"swiper-wrapper\"></d> <d c=\"swiper-button-next overlay-next swiper-button-white\"></d> <d c=\"swiper-button-prev overlay-prev swiper-button-white\"></d> </d> ");
              for (i = newElems.length - 1; i >= 0; i--) {
                ui.core.mapDivDocument.insertBefore(newElems[i], ui.core.mapDivDocument.firstChild);
              }
              prevDefs = ui.core.mapDivDocument.querySelectorAll(".prevent-default-ui");
              for (_i = 0; _i < prevDefs.length; _i++) {
                target = prevDefs[_i];
                target.addEventListener("touchstart", function (evt) {
                  evt.preventDefault();
                });
              }
              newElems = createElement("<d c=\"modal modalBase\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"staticModalLabel\" aria-hidden=\"true\" data-show=\"true\" data-keyboard=\"false\" data-backdrop=\"static\"> <d c=\"modal-dialog\"> <d c=\"modal-content\"> <d c=\"modal-header\"> <button type=\"button\" c=\"close\" data-dismiss=\"modal\"> <s aria-hidden=\"true\">&#215;</s><s c=\"sr-only\" din=\"html.close\"></s> </button> <h4 c=\"modal-title\"> <s c=\"modal_title\"></s> <s c=\"modal_load_title\"></s> <s c=\"modal_gpsW_title\" din=\"html.acquiring_gps\"></s> <s c=\"modal_help_title\" din=\"html.help_title\"></s> <s c=\"modal_share_title\" din=\"html.share_title\"></s> <s c=\"modal_hide_marker_title\" din=\"html.hide_marker_title\"></s> </h4> </d> <d c=\"modal-body\"> <d c=\"modal_help_content\"> <d c=\"help_content\"> <s dinh=\"html.help_using_maplat\"></s> <p c=\"col-xs-12 help_img\"><img src=\"".concat(pointer["fullscreen.png"], "\"></p> <h4 din=\"html.help_operation_title\"></h4> <p dinh=\"html.help_operation_content\" c=\"recipient\"></p> <h4 din=\"html.help_selection_title\"></h4> <p dinh=\"html.help_selection_content\" c=\"recipient\"></p> <h4 din=\"html.help_gps_title\"></h4> <p dinh=\"html.help_gps_content\" c=\"recipient\"></p> <h4 din=\"html.help_poi_title\"></h4> <p dinh=\"html.help_poi_content\" c=\"recipient\"></p> <h4 din=\"html.help_etc_title\"></h4> <ul> <li dinh=\"html.help_etc_attr\" c=\"recipient\"></li> <li dinh=\"html.help_etc_help\" c=\"recipient\"></li> <s c=\"share_help\"><li dinh=\"html.help_share_help\" c=\"recipient\"></li></s> <s c=\"border_help\"><li dinh=\"html.help_etc_border\" c=\"recipient\"></li></s> <s c=\"hide_marker_help\"><li dinh=\"html.help_etc_hide_marker\" c=\"recipient\"></li></s> <li dinh=\"html.help_etc_slider\" c=\"recipient\"></li> </ul> <p><a href=\"https://github.com/code4history/Maplat/wiki\" target=\"_blank\">Maplat</a> © 2015- Kohei Otsuka, Code for History</p> </d> </d> <d c=\"modal_poi_content\"> <d c=\"poi_web").concat(enablePoiHtmlNoScroll ? "" : " embed-responsive embed-responsive-60vh", "\"> <iframe c=\"poi_iframe iframe_poi\" frameborder=\"0\" src=\"\"").concat(enablePoiHtmlNoScroll ? " onload=\"window.addEventListener('message', (e) =>{if (e.data[0] == 'setHeight') {console.log(this.style.height = e.data[1]);}});\" scrolling=\"no\"" : "", "></iframe> </d> <d c=\"poi_data hide\"> <d c=\"col-xs-12 swiper-container poi_img_swiper\"> <d c=\"swiper-wrapper\"></d> <d c=\"swiper-pagination poi-pagination\"></d> <d c=\"swiper-button-next poi-img-next\"></d> <d c=\"swiper-button-prev poi-img-prev\"></d> </d> <p c=\"recipient poi_address\"></p> <p c=\"recipient poi_desc\"></p> </d> </d> <d c=\"modal_share_content\"> <h4 din=\"html.share_app_title\"></h4> <d id=\"___maplat_app_toast_").concat(ui.html_id_seed, "\"></d> <d c=\"recipient row\"> <d c=\"form-group col-xs-4 text-center\"><button title=\"Copy to clipboard\" c=\"share btn btn-light\" data=\"cp_app\"><i c=\"fa fa-clipboard\"></i>&nbsp;<small din=\"html.share_copy\"></small></button></d> <d c=\"form-group col-xs-4 text-center\"><button title=\"Twitter\" c=\"share btn btn-light\" data=\"tw_app\"><i c=\"fa fa-twitter\"></i>&nbsp;<small>Twitter</small></button></d> <d c=\"form-group col-xs-4 text-center\"><button title=\"Facebook\" c=\"share btn btn-light\" data=\"fb_app\"><i c=\"fa fa-facebook\"></i>&nbsp;<small>Facebook</small></button></d> </d> <d c=\"qr_app center-block\" style=\"width:128px;\"></d> <d c=\"modal_share_state\"> <h4 din=\"html.share_state_title\"></h4> <d id=\"___maplat_view_toast_").concat(ui.html_id_seed, "\"></d> <d c=\"recipient row\"> <d c=\"form-group col-xs-4 text-center\"><button title=\"Copy to clipboard\" c=\"share btn btn-light\" data=\"cp_view\"><i c=\"fa fa-clipboard\"></i>&nbsp;<small din=\"html.share_copy\"></small></button></d> <d c=\"form-group col-xs-4 text-center\"><button title=\"Twitter\" c=\"share btn btn-light\" data=\"tw_view\"><i c=\"fa fa-twitter\"></i>&nbsp;<small>Twitter</small></button></d> <d c=\"form-group col-xs-4 text-center\"><button title=\"Facebook\" c=\"share btn btn-light\" data=\"fb_view\"><i c=\"fa fa-facebook\"></i>&nbsp;<small>Facebook</small></button></d> </d> <d c=\"qr_view center-block\" style=\"width:128px;\"></d> </d> <p><img src=\"\" height=\"0px\" width=\"0px\"></p> </d> <d c=\"modal_map_content\"> ").concat(META_KEYS.map(function (key) {
                if (key == "title" || key == "officialTitle") return "";
                return "<d c=\"recipients ".concat(key, "_div\"><dl c=\"dl-horizontal\"> <dt din=\"html.").concat(key, "\"></dt> <dd c=\"").concat(key, "_dd\"></dd> </dl></d> ");
              }).join(""), " <d c=\"recipients modal_cache_content\"><dl c=\"dl-horizontal\"> <dt din=\"html.cache_handle\"></dt> <dd><s c=\"cache_size\"></s></dd> <dt></dt> <dd><s c=\"pull-right\"><button c=\"cache_fetch btn btn-default\" href=\"#\" din=\"html.cache_fetch\"></button> <button c=\"cache_delete btn btn-default\" href=\"#\" din=\"html.cache_delete\"></button></s></dd> </dl></d> </d> <d c=\"modal_load_content\"> <p c=\"recipient\"><img src=\"").concat(pointer["loading.png"], "\"><s din=\"html.app_loading_body\"></s></p> <d c=\"splash_div hide row\"><p c=\"col-xs-12 poi_img\"><img c=\"splash_img\" src=\"\"></p></d> <p><img src=\"\" height=\"0px\" width=\"0px\"></p> </d> <d c=\"modal_hide_marker_content\"> <ul c=\"list-group\"></ul> </d> <p c=\"modal_gpsD_content\" c=\"recipient\"></p> <p c=\"modal_gpsW_content\" c=\"recipient\"></p> </d> </d> </d> </d> "));
              for (_i2 = newElems.length - 1; _i2 >= 0; _i2--) {
                ui.core.mapDivDocument.insertBefore(newElems[_i2], ui.core.mapDivDocument.firstChild);
              }
              shareBtns = ui.core.mapDivDocument.querySelectorAll(".btn.share");
              for (_i3 = 0; _i3 < shareBtns.length; _i3++) {
                shareBtn = shareBtns[_i3];
                shareBtn.addEventListener("click", function (evt) {
                  var btn = evt.target;
                  if (!btn.classList.contains("share")) btn = btn.parentElement;
                  var cmd = btn.getAttribute("data");
                  var cmds = cmd.split("_");
                  var base = evt.target.baseURI;
                  if (!base) base = window.location.href;
                  var div1 = base.split("#!");
                  var path = div1.length > 1 ? div1[1].split("?")[0] : "";
                  var div2 = div1[0].split("?");
                  var uri = div2[0];
                  var query = div2.length > 1 ? div2[1].split("&").filter(function (qs) {
                    return qs !== "pwa";
                  }).join("&") : "";
                  if (query) uri = "".concat(uri, "?").concat(query);
                  if (cmds[1] === "view") {
                    if (path) uri = "".concat(uri, "#!").concat(path);
                  }
                  if (cmds[0] === "cp") {
                    var copyFrom = document.createElement("textarea"); // eslint-disable-line no-undef
                    copyFrom.textContent = uri;
                    var bodyElm = document.querySelector("body"); // eslint-disable-line no-undef
                    bodyElm.appendChild(copyFrom);
                    if (/iP(hone|[oa]d)/.test(navigator.userAgent)) {
                      // eslint-disable-line no-undef
                      var range = document.createRange(); // eslint-disable-line no-undef
                      range.selectNode(copyFrom);
                      window.getSelection().addRange(range); // eslint-disable-line no-undef
                    } else {
                      copyFrom.select();
                    }
                    document.execCommand("copy"); // eslint-disable-line no-undef
                    bodyElm.removeChild(copyFrom);
                    var toastParent = "#___maplat_".concat(cmds[1], "_toast_").concat(ui.html_id_seed);
                    iziToast.show({
                      message: ui.core.t("app.copy_toast", {
                        ns: "translation"
                      }),
                      close: false,
                      pauseOnHover: false,
                      timeout: 1000,
                      progressBar: false,
                      target: toastParent
                    });
                  } else if (cmds[0] === "tw") {
                    var twuri = "https://twitter.com/share?url=".concat(encodeURIComponent(uri), "&hashtags=Maplat");
                    window.open(twuri, "_blank", "width=650,height=450,menubar=no,toolbar=no,scrollbars=yes"); // eslint-disable-line no-undef
                  } else if (cmds[0] === "fb") {
                    // https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2Fshare-button%2F&display=popup&ref=plugin&src=like&kid_directed_site=0&app_id=113869198637480
                    var fburi = "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(uri), "&display=popup&ref=plugin&src=like&kid_directed_site=0");
                    window.open(fburi, "_blank", "width=650,height=450,menubar=no,toolbar=no,scrollbars=yes"); // eslint-disable-line no-undef
                  }
                });
              }

              // PWA対応: 非同期処理
              if (pwaManifest) {
                if (pwaManifest === true) {
                  pwaManifest = "./pwa/".concat(ui.core.appid, "_manifest.json");
                }
                if (!pwaWorker) {
                  pwaWorker = "./service-worker.js";
                }
                if (!pwaScope) {
                  pwaScope = "./";
                }
                head = document.querySelector("head"); // eslint-disable-line no-undef
                if (!head.querySelector('link[rel=\"manifest\"]')) {
                  head.appendChild(createElement("<link rel=\"manifest\" href=\"".concat(pwaManifest, "\">"))[0]);
                }
                // service workerが有効なら、service-worker.js を登録します
                try {
                  Weiwudi.registerSW(pwaWorker, {
                    scope: pwaScope
                  });
                } catch (e) {} // eslint-disable-line no-empty

                if (!head.querySelector('link[rel=\"apple-touch-icon\"]')) {
                  xhr = new XMLHttpRequest(); // eslint-disable-line no-undef
                  xhr.open("GET", pwaManifest, true);
                  xhr.responseType = "json";
                  xhr.onload = function (_e) {
                    var value = this.response;
                    if (!value) return;
                    if (_typeof(value) != "object") value = JSON.parse(value);
                    if (value.icons) {
                      for (var _i4 = 0; _i4 < value.icons.length; _i4++) {
                        var src = absoluteUrl(pwaManifest, value.icons[_i4].src);
                        var sizes = value.icons[_i4].sizes;
                        var tag = "<link rel=\"apple-touch-icon\" sizes=\"".concat(sizes, "\" href=\"").concat(src, "\">");
                        head.appendChild(createElement(tag)[0]);
                      }
                    }
                  };
                  xhr.send();
                }
              }
              ui.core.addEventListener("uiPrepare", function (_evt) {
                var imageExtractor = function imageExtractor(text) {
                  var regexp = /\$\{([a-zA-Z0-9_\.\/\-]+)\}/g; // eslint-disable-line no-useless-escape
                  var ret = text;
                  var match;
                  while ((match = regexp.exec(text)) != null) {
                    ret = ret.replace(match[0], pointer[match[1]]);
                  }
                  return ret;
                };
                var i18nTargets = ui.core.mapDivDocument.querySelectorAll("[data-i18n]");
                for (var _i5 = 0; _i5 < i18nTargets.length; _i5++) {
                  var _target = i18nTargets[_i5];
                  var key = _target.getAttribute("data-i18n");
                  _target.innerText = imageExtractor(ui.core.t(key));
                }
                i18nTargets = ui.core.mapDivDocument.querySelectorAll("[data-i18n-html]");
                for (var _i6 = 0; _i6 < i18nTargets.length; _i6++) {
                  var _target2 = i18nTargets[_i6];
                  var _key = _target2.getAttribute("data-i18n-html");
                  _target2.innerHTML = imageExtractor(ui.core.t(_key));
                }
                var options = {
                  reverse: true,
                  tipLabel: ui.core.t("control.trans", {
                    ns: "translation"
                  })
                };
                if (restoreTransparency) {
                  options.initialValue = restoreTransparency / 100;
                }
                ui.sliderNew = new SliderNew(options);
                ui.core.appData.controls = [new Copyright({
                  tipLabel: ui.core.t("control.info", {
                    ns: "translation"
                  })
                }), new CompassRotate({
                  tipLabel: ui.core.t("control.compass", {
                    ns: "translation"
                  })
                }), new Zoom({
                  tipLabel: ui.core.t("control.zoom", {
                    ns: "translation"
                  })
                }), new SetGPS({
                  ui: ui,
                  tipLabel: ui.core.t("control.gps", {
                    ns: "translation"
                  })
                }), new GoHome({
                  tipLabel: ui.core.t("control.home", {
                    ns: "translation"
                  })
                }), ui.sliderNew, new Maplat({
                  tipLabel: ui.core.t("control.help", {
                    ns: "translation"
                  })
                })];
                if (ui.enableShare) {
                  ui.core.appData.controls.push(new Share({
                    tipLabel: ui.core.t("control.share", {
                      ns: "translation"
                    })
                  }));
                }
                if (ui.enableBorder) {
                  ui.core.appData.controls.push(new Border({
                    tipLabel: ui.core.t("control.border", {
                      ns: "translation"
                    })
                  }));
                }
                if (ui.enableHideMarker) {
                  ui.core.appData.controls.push(new HideMarker({
                    tipLabel: ui.core.t("control.hide_marker", {
                      ns: "translation"
                    })
                  }));
                }

                // Contextmenu
                ui.contextMenu = new ContextMenu({
                  eventType: "__dummy__",
                  width: 170,
                  defaultItems: false,
                  items: []
                });
                ui.core.appData.controls.push(ui.contextMenu);
                ui.sliderNew.on("propertychange", function (evt) {
                  if (evt.key === "slidervalue") {
                    ui.core.setTransparency(ui.sliderNew.get(evt.key) * 100);
                  }
                });
                if (enableSplash) {
                  // Check Splash data
                  var splash = false;
                  if (ui.core.appData.splash) splash = true;
                  var modalElm = ui.core.mapDivDocument.querySelector(".modalBase");
                  var modal = new bsn.Modal(modalElm, {
                    root: ui.core.mapDivDocument
                  });
                  ui.core.mapDivDocument.querySelector(".modal_load_title").innerText = ui.core.translate(ui.core.appData.appName);
                  if (splash) {
                    ui.core.mapDivDocument.querySelector(".splash_img").setAttribute("src", "img/".concat(ui.core.appData.splash));
                    ui.core.mapDivDocument.querySelector(".splash_div").classList.remove("hide");
                  }
                  ui.modalSetting("load");
                  modal.show();
                  var fadeTime = splash ? 1000 : 200;
                  ui.splashPromise = new Promise(function (resolve) {
                    setTimeout(function () {
                      // eslint-disable-line no-undef
                      resolve();
                    }, fadeTime);
                  });
                }
                document.querySelector("title").innerHTML = ui.core.translate(ui.core.appName); // eslint-disable-line no-undef
              });
              ui.core.addEventListener("sourceLoaded", function (evt) {
                var sources = evt.detail;
                var colors = ["maroon", "deeppink", "indigo", "olive", "royalblue", "red", "hotpink", "green", "yellow", "navy", "saddlebrown", "fuchsia", "darkslategray", "yellowgreen", "blue", "mediumvioletred", "purple", "lime", "darkorange", "teal", "crimson", "darkviolet", "darkolivegreen", "steelblue", "aqua"];
                var appBbox = [];
                var cIndex = 0;
                for (var _i7 = 0; _i7 < sources.length; _i7++) {
                  var source = sources[_i7];
                  if (source.envelope) {
                    if (ui.appEnvelope) source.envelope.geometry.coordinates[0].map(function (xy) {
                      if (appBbox.length === 0) {
                        appBbox[0] = appBbox[2] = xy[0];
                        appBbox[1] = appBbox[3] = xy[1];
                      } else {
                        if (xy[0] < appBbox[0]) appBbox[0] = xy[0];
                        if (xy[0] > appBbox[2]) appBbox[2] = xy[0];
                        if (xy[1] < appBbox[1]) appBbox[1] = xy[1];
                        if (xy[1] > appBbox[3]) appBbox[3] = xy[1];
                      }
                    });
                    source.envelopeColor = colors[cIndex];
                    cIndex = cIndex + 1;
                    if (cIndex === colors.length) cIndex = 0;
                    var xys = source.envelope.geometry.coordinates[0];
                    // http://blog.arq.name/wp-content/uploads/2018/02/Rectangle_Area.pdf
                    source.envelopeAreaIndex = ui.areaIndex(xys);
                  }
                }
                if (ui.appEnvelope) console.log("This app's envelope is: ".concat(appBbox));
                if (ui.splashPromise) {
                  ui.splashPromise.then(function () {
                    var modalElm = ui.core.mapDivDocument.querySelector(".modalBase");
                    var modal = new bsn.Modal(modalElm, {
                      root: ui.core.mapDivDocument
                    });
                    ui.modalSetting("load");
                    modal.hide();
                  });
                }
                var baseSources = [];
                var overlaySources = [];
                for (var _i8 = 0; _i8 < sources.length; _i8++) {
                  var _source = sources[_i8];
                  if (_source instanceof NowMap && !(_source instanceof TmsMap) || _source instanceof GoogleMap) {
                    baseSources.push(_source);
                  } else {
                    overlaySources.push(_source);
                  }
                }
                var baseSwiper = ui.baseSwiper = new Swiper(".base-swiper", {
                  slidesPerView: 2,
                  spaceBetween: 15,
                  breakpoints: {
                    // when window width is <= 480px
                    480: {
                      slidesPerView: 1.4,
                      spaceBetween: 10
                    }
                  },
                  centeredSlides: true,
                  threshold: 2,
                  loop: baseSources.length >= 2,
                  navigation: {
                    nextEl: ".base-next",
                    prevEl: ".base-prev"
                  }
                });
                baseSwiper.on("click", function (_e) {
                  if (!baseSwiper.clickedSlide) return;
                  var slide = baseSwiper.clickedSlide;
                  ui.core.changeMap(slide.getAttribute("data"));
                  delete ui._selectCandidateSources;
                  baseSwiper.setSlideIndexAsSelected(slide.getAttribute("data-swiper-slide-index"));
                });
                if (baseSources.length < 2) {
                  ui.core.mapDivDocument.querySelector(".base-swiper").classList.add("single-map");
                }
                var overlaySwiper = ui.overlaySwiper = new Swiper(".overlay-swiper", {
                  slidesPerView: 2,
                  spaceBetween: 15,
                  breakpoints: {
                    // when window width is <= 480px
                    480: {
                      slidesPerView: 1.4,
                      spaceBetween: 10
                    }
                  },
                  centeredSlides: true,
                  threshold: 2,
                  loop: overlaySources.length >= 2,
                  navigation: {
                    nextEl: ".overlay-next",
                    prevEl: ".overlay-prev"
                  }
                });
                overlaySwiper.on("click", function (_e) {
                  if (!overlaySwiper.clickedSlide) return;
                  var slide = overlaySwiper.clickedSlide;
                  ui.core.changeMap(slide.getAttribute("data"));
                  delete ui._selectCandidateSources;
                  overlaySwiper.setSlideIndexAsSelected(slide.getAttribute("data-swiper-slide-index"));
                });
                if (overlaySources.length < 2) {
                  ui.core.mapDivDocument.querySelector(".overlay-swiper").classList.add("single-map");
                }
                for (var _i9 = 0; _i9 < baseSources.length; _i9++) {
                  var _source2 = baseSources[_i9];
                  baseSwiper.appendSlide("<div class=\"swiper-slide\" data=\"".concat(_source2.mapID, "\">") + "<img crossorigin=\"anonymous\" src=\"".concat(_source2.thumbnail, "\"><div> ").concat(ui.core.translate(_source2.label), "</div> </div> "));
                }
                for (var _i10 = 0; _i10 < overlaySources.length; _i10++) {
                  var _source3 = overlaySources[_i10];
                  var colorCss = _source3.envelope ? " ".concat(_source3.envelopeColor) : "";
                  overlaySwiper.appendSlide("<div class=\"swiper-slide".concat(colorCss, "\" data=\"").concat(_source3.mapID, "\">") + "<img crossorigin=\"anonymous\" src=\"".concat(_source3.thumbnail, "\"><div> ").concat(ui.core.translate(_source3.label), "</div> </div> "));
                }
                baseSwiper.on;
                overlaySwiper.on;
                baseSwiper.slideToLoop(0);
                overlaySwiper.slideToLoop(0);
                ui.ellips();
              });
              ui.core.addEventListener("mapChanged", function (evt) {
                var map = evt.detail;
                ui.baseSwiper.setSlideMapID(map.mapID);
                ui.overlaySwiper.setSlideMapID(map.mapID);
                var title = map.officialTitle || map.title || map.label;
                ui.core.mapDivDocument.querySelector(".map-title span").innerText = ui.core.translate(title);
                if (ui.checkOverlayID(map.mapID)) {
                  ui.sliderNew.setEnable(true);
                } else {
                  ui.sliderNew.setEnable(false);
                }
                var transparency = ui.sliderNew.get("slidervalue") * 100;
                ui.core.mapObject.setTransparency(transparency);
                ui.updateEnvelope();
              });
              ui.core.addEventListener("poi_number", function (evt) {
                var number = evt.detail;
                if (number) {
                  ui.core.mapDivDocument.classList.remove("no_poi");
                } else {
                  ui.core.mapDivDocument.classList.add("no_poi");
                }
              });
              ui.core.addEventListener("outOfMap", function (_evt) {
                if (enableOutOfMap) {
                  ui.core.mapDivDocument.querySelector(".modal_title").innerText = ui.core.t("app.out_of_map");
                  ui.core.mapDivDocument.querySelector(".modal_gpsD_content").innerText = ui.core.t("app.out_of_map_area");
                  var modalElm = ui.core.mapDivDocument.querySelector(".modalBase");
                  var modal = new bsn.Modal(modalElm, {
                    root: ui.core.mapDivDocument
                  });
                  ui.modalSetting("gpsD");
                  modal.show();
                }
              });
              ui.core.mapDivDocument.addEventListener("mouseout", function (_evt) {
                if (ui._selectCandidateSources) {
                  Object.keys(ui._selectCandidateSources).forEach(function (key) {
                    return ui.core.mapObject.removeEnvelope(ui._selectCandidateSources[key]);
                  });
                  delete ui._selectCandidateSources;
                }
              });
              ui.core.addEventListener("pointerMoveOnMapXy", /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(evt) {
                  var mapIDs;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (ui.core.stateBuffer.showBorder) {
                          _context.next = 3;
                          break;
                        }
                        if (ui._selectCandidateSources) {
                          Object.keys(ui._selectCandidateSources).forEach(function (key) {
                            return ui.core.mapObject.removeEnvelope(ui._selectCandidateSources[key]);
                          });
                          delete ui._selectCandidateSources;
                        }
                        return _context.abrupt("return");
                      case 3:
                        _context.next = 5;
                        return ui.xyToMapIDs(evt.detail);
                      case 5:
                        mapIDs = _context.sent;
                        ui.showFillEnvelope(mapIDs);
                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
              ui.core.addEventListener("clickMapXy", /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(evt) {
                  var mapIDs, currentID;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        if (ui.core.stateBuffer.showBorder) {
                          _context2.next = 2;
                          break;
                        }
                        return _context2.abrupt("return");
                      case 2:
                        _context2.next = 4;
                        return ui.xyToMapIDs(evt.detail);
                      case 4:
                        mapIDs = _context2.sent;
                        if (mapIDs.length > 0) {
                          showContextMenu(mapIDs.map(function (mapID) {
                            var source = ui.core.cacheHash[mapID];
                            var hexColor = source.envelopeColor;
                            var iconSVG = "<?xml version=\"1.0\" encoding=\"utf-8\"?><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"10px\" height=\"10px\" viewBox=\"0 0 10 10\" enable-background=\"new 0 0 10 10\" xml:space=\"preserve\"> <polygon x=\"0\" y=\"0\" points=\"2,2 2,8 8,8 8,2 2,2\" stroke=\"".concat(hexColor, "\" fill=\"").concat(hexColor, "\" stroke-width=\"2\" style=\"fill-opacity: .25;\"></polygon></svg>");
                            iconSVG = "data:image/svg+xml,".concat(encodeURIComponent(iconSVG));
                            return {
                              icon: iconSVG,
                              text: ui.core.translate(source.title),
                              callback: function callback() {
                                var lis = _toConsumableArray(ui.core.mapDivDocument.querySelectorAll(".ol-ctx-menu-container ul li"));
                                lis.forEach(function (li) {
                                  return li.classList.remove("selected");
                                });
                                if (currentID && currentID === mapID) {
                                  delete ui._selectCandidateSources;
                                  ui.core.changeMap(mapID);
                                } else {
                                  currentID = mapID;
                                  ui.showFillEnvelope([mapID]);
                                  ui.overlaySwiper.slideToMapID(mapID);
                                  var index = mapIDs.indexOf(mapID);
                                  if (index > -1) {
                                    var li = lis[index];
                                    li.classList.add("selected");
                                  }
                                  return true;
                                }
                              },
                              mouseOnTask: function mouseOnTask(_evt) {
                                if (!ui.isTouch) {
                                  currentID = mapID;
                                  ui.showFillEnvelope([mapID]);
                                  ui.overlaySwiper.slideToMapID(mapID);
                                }
                              },
                              mouseOutTask: function mouseOutTask(_evt) {
                                if (!ui.isTouch) {
                                  currentID = undefined;
                                  ui.showFillEnvelope([]);
                                }
                              }
                            };
                          }));
                          ui.showFillEnvelope(mapIDs);
                        }
                      case 6:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
              ui.core.addEventListener("clickMarkers", function (evt) {
                var data = evt.detail;
                if (data.length === 1) {
                  ui.handleMarkerAction(data[0]);
                } else {
                  showContextMenu(data.map(function (datum) {
                    return {
                      icon: datum.icon || pointer["defaultpin.png"],
                      text: ui.core.translate(datum.name),
                      callback: function callback() {
                        ui.handleMarkerAction(datum);
                      }
                    };
                  }));
                }
              });
              if (appOption.stateUrl) {
                ui.core.addEventListener("updateState", function (evt) {
                  var value = evt.detail;
                  if (!value.position || !value.mapID) return;
                  var link = "s:".concat(value.mapID);
                  if (value.backgroundID) link = "".concat(link, "/b:").concat(value.backgroundID);
                  if (value.transparency) link = "".concat(link, "/t:").concat(value.transparency);
                  link = "".concat(link, "/x:").concat(value.position.x, "/y:").concat(value.position.y);
                  link = "".concat(link, "/z:").concat(value.position.zoom);
                  if (value.position.rotation) link = "".concat(link, "/r:").concat(value.position.rotation);
                  if (value.showBorder) link = "".concat(link, "/sb:").concat(value.showBorder);
                  if (value.hideMarker) link = "".concat(link, "/hm:").concat(value.hideMarker);
                  if (value.hideLayer) link = "".concat(link, "/hl:").concat(value.hideLayer);
                  ui.pathThatSet = link;
                  page(link);
                });
              }
              ui.waitReady = ui.core.waitReady.then(function () {
                var fakeGps = appOption.fake ? ui.core.appData.fakeGps : false;
                var fakeCenter = appOption.fake ? ui.core.appData.fakeCenter : false;
                var fakeRadius = appOption.fake ? ui.core.appData.fakeRadius : false;
                var geolocation = new Geolocation({
                  timerBase: appOption.fake,
                  homePosition: ui.core.appData.homePosition
                });
                geolocation.setTracking(true);
                ui.geolocation = geolocation;

                /*let shown = false;
                let gpsWaitPromise = null;
                  if (ui.alwaysGpsOn) {
                  ui.core.mapObject.handleGPS(true);
                }
                  const showGPSresult = ui.alwaysGpsOn ?
                (result) => {
                  // 常時GPSオンの処理
                  if (result && result.error === "gps_error") {
                    // GPS取得のエラーだけは、ケアする
                    } else {
                    }
                } :
                (result) => {
                  // デフォルトのGPS処理
                  if (result && result.error) {
                    ui.core.currentPosition = null;
                    if (result.error === "gps_out" && shown) {
                      shown = false;
                      const modalElm = ui.core.mapDivDocument.querySelector(".modalBase");
                      const modal = new bsn.Modal(modalElm, {
                        root: ui.core.mapDivDocument
                      });
                      ui.core.mapDivDocument.querySelector(".modal_title").innerText =
                        ui.core.t("app.out_of_map");
                      ui.core.mapDivDocument.querySelector(
                        ".modal_gpsD_content"
                      ).innerText = ui.core.t("app.out_of_map_desc");
                      ui.modalSetting("gpsD");
                      modal.show();
                    }
                  } else {
                    ui.core.currentPosition = result;
                  }
                  if (shown) {
                    shown = false;
                    const modalElm = ui.core.mapDivDocument.querySelector(".modalBase");
                    const modal = new bsn.Modal(modalElm, {
                      root: ui.core.mapDivDocument
                    });
                    modal.hide();
                  }
                }
                ui.core.mapObject.on("gps_request", () => {
                  gpsWaitPromise = "gps_request";
                  const promises = [
                    new Promise(resolve => {
                      if (gpsWaitPromise !== "gps_request") {
                        resolve(gpsWaitPromise);
                      } else gpsWaitPromise = resolve;
                    })
                  ];
                  shown = true;
                  const modalElm = ui.core.mapDivDocument.querySelector(".modalBase");
                  const modal = new bsn.Modal(modalElm, { root: ui.core.mapDivDocument });
                  ui.modalSetting("gpsW");
                  modal.show();
                  // 200m秒以上最低待たないと、Modalがうまく動かない場合がある
                  promises.push(
                    new Promise(resolve => {
                      setTimeout(resolve, 200); // eslint-disable-line no-undef
                    })
                  );
                  Promise.all(promises).then(results => {
                    showGPSresult(results[0]);
                  });
                });
                ui.core.mapObject.on("gps_result", evt => {
                  if (gpsWaitPromise === "gps_request") {
                    gpsWaitPromise = evt.detail;
                  } else if (gpsWaitPromise) {
                    gpsWaitPromise(evt.detail);
                    gpsWaitPromise = null;
                  } else if (!shown) {
                    showGPSresult(evt.detail);
                  }
                });*/

                var qr_app;
                var qr_view;
                ui.core.mapObject.on("click_control", /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(evt) {
                    var control, modalElm, modal, from, deleteButton, fetchButton, putTileCacheStats, cacheDiv, cacheEnable, deleteFunc, cancelFunc, fetchFunc, hideFunc, base, div1, path, div2, uri, query, view, flag, _flag, layers, elem, _modalElm;
                    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                      while (1) switch (_context7.prev = _context7.next) {
                        case 0:
                          control = evt.frameState.control;
                          modalElm = ui.core.mapDivDocument.querySelector(".modalBase");
                          modal = new bsn.Modal(modalElm, {
                            root: ui.core.mapDivDocument
                          });
                          if (!(control === "copyright")) {
                            _context7.next = 34;
                            break;
                          }
                          from = ui.core.getMapMeta();
                          if (META_KEYS.reduce(function (prev, curr) {
                            if (curr === "title") return prev;
                            return from[curr] || prev;
                          }, false)) {
                            _context7.next = 7;
                            break;
                          }
                          return _context7.abrupt("return");
                        case 7:
                          ui.core.mapDivDocument.querySelector(".modal_title").innerText = ui.core.translate(from.officialTitle || from.title);
                          META_KEYS.map(function (key) {
                            if (key === "title" || key === "officialTitle") return;
                            if (!from[key] || from[key] === "") {
                              ui.core.mapDivDocument.querySelector(".".concat(key, "_div")).classList.add("hide");
                            } else {
                              ui.core.mapDivDocument.querySelector(".".concat(key, "_div")).classList.remove("hide");
                              ui.core.mapDivDocument.querySelector(".".concat(key, "_dd")).innerHTML = key === "license" || key === "dataLicense" ? "<img src=\"".concat(pointer["".concat(from[key].toLowerCase().replace(/ /g, "_"), ".png")], "\">") : ui.core.translate(from[key]);
                            }
                          });
                          deleteButton = ui.core.mapDivDocument.querySelector(".cache_delete"); // eslint-disable-line no-undef
                          fetchButton = ui.core.mapDivDocument.querySelector(".cache_fetch"); // eslint-disable-line no-undef
                          putTileCacheStats = function putTileCacheStats(stats) {
                            var size = stats.size || 0;
                            var unit = "Bytes";
                            if (size !== -1) {
                              if (size > 1024) {
                                size = Math.round(size * 10 / 1024) / 10;
                                unit = "KBytes";
                              }
                              if (size > 1024) {
                                size = Math.round(size * 10 / 1024) / 10;
                                unit = "MBytes";
                              }
                              if (size > 1024) {
                                size = Math.round(size * 10 / 1024) / 10;
                                unit = "GBytes";
                              }
                            }
                            var content = size === -1 ? ui.core.t("html.cache_processing") : "".concat(size, " ").concat(unit);
                            if (stats.total) {
                              content = "".concat(content, " (").concat(stats.count, " / ").concat(stats.total, " tiles [").concat(stats.percent, "%])");
                            } else {
                              content = "".concat(content, " (").concat(stats.count, " tiles)");
                            }
                            ui.core.mapDivDocument.querySelector(".cache_size").innerHTML = content;
                            if (stats.count != 0) {
                              deleteButton.removeAttribute("disabled");
                            } else {
                              deleteButton.setAttribute("disabled", true);
                            }
                            if (stats.total) {
                              fetchButton.classList.remove("hide");
                              if (stats.total === stats.count) {
                                fetchButton.setAttribute("disabled", true);
                              } else {
                                fetchButton.removeAttribute("disabled");
                              }
                            } else {
                              fetchButton.classList.add("hide");
                            }
                          };
                          ui.modalSetting("map");
                          cacheDiv = ui.core.mapDivDocument.querySelector(".modal_cache_content");
                          cacheEnable = ui.core.getMapCacheEnable(from.mapID);
                          if (!cacheEnable) {
                            _context7.next = 30;
                            break;
                          }
                          cacheDiv.classList.remove("hide");
                          deleteFunc = /*#__PURE__*/function () {
                            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(evt) {
                              var from;
                              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                                while (1) switch (_context3.prev = _context3.next) {
                                  case 0:
                                    evt.preventDefault();
                                    from = ui.core.getMapMeta();
                                    _context3.next = 4;
                                    return ui.core.clearMapTileCacheAsync(from.mapID);
                                  case 4:
                                    _context3.t0 = putTileCacheStats;
                                    _context3.next = 7;
                                    return ui.core.getMapTileCacheStatsAsync(from.mapID);
                                  case 7:
                                    _context3.t1 = _context3.sent;
                                    (0, _context3.t0)(_context3.t1);
                                  case 9:
                                  case "end":
                                    return _context3.stop();
                                }
                              }, _callee3);
                            }));
                            return function deleteFunc(_x5) {
                              return _ref4.apply(this, arguments);
                            };
                          }();
                          cancelFunc = /*#__PURE__*/function () {
                            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(evt) {
                              var from;
                              return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                                while (1) switch (_context4.prev = _context4.next) {
                                  case 0:
                                    if (evt) evt.preventDefault();
                                    from = ui.core.getMapMeta();
                                    _context4.next = 4;
                                    return ui.core.cancelMapTileCacheAsync(from.mapID);
                                  case 4:
                                  case "end":
                                    return _context4.stop();
                                }
                              }, _callee4);
                            }));
                            return function cancelFunc(_x6) {
                              return _ref5.apply(this, arguments);
                            };
                          }();
                          fetchFunc = /*#__PURE__*/function () {
                            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(evt) {
                              var closeButton, from;
                              return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                                while (1) switch (_context6.prev = _context6.next) {
                                  case 0:
                                    closeButton = ui.core.mapDivDocument.querySelector(".close");
                                    evt.preventDefault();
                                    fetchButton.innerHTML = ui.core.t("html.cache_cancel");
                                    fetchButton.removeEventListener("click", fetchFunc);
                                    fetchButton.addEventListener("click", cancelFunc);
                                    closeButton.classList.add("temp_no_close");
                                    from = ui.core.getMapMeta();
                                    _context6.next = 9;
                                    return ui.core.fetchAllMapTileCacheAsync(from.mapID, /*#__PURE__*/function () {
                                      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(type, data) {
                                        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                                          while (1) switch (_context5.prev = _context5.next) {
                                            case 0:
                                              _context5.t0 = type;
                                              _context5.next = _context5.t0 === "proceed" ? 3 : _context5.t0 === "canceled" ? 5 : _context5.t0 === "stop" ? 5 : _context5.t0 === "finish" ? 5 : 14;
                                              break;
                                            case 3:
                                              putTileCacheStats({
                                                count: data.processed,
                                                total: data.total,
                                                percent: data.percent,
                                                size: -1
                                              });
                                              return _context5.abrupt("return");
                                            case 5:
                                              fetchButton.innerHTML = ui.core.t("html.cache_fetch");
                                              fetchButton.removeEventListener("click", cancelFunc);
                                              fetchButton.addEventListener("click", fetchFunc);
                                              closeButton.classList.remove("temp_no_close");
                                              _context5.t1 = putTileCacheStats;
                                              _context5.next = 12;
                                              return ui.core.getMapTileCacheStatsAsync(from.mapID);
                                            case 12:
                                              _context5.t2 = _context5.sent;
                                              (0, _context5.t1)(_context5.t2);
                                            case 14:
                                            case "end":
                                              return _context5.stop();
                                          }
                                        }, _callee5);
                                      }));
                                      return function (_x8, _x9) {
                                        return _ref7.apply(this, arguments);
                                      };
                                    }());
                                  case 9:
                                  case "end":
                                    return _context6.stop();
                                }
                              }, _callee6);
                            }));
                            return function fetchFunc(_x7) {
                              return _ref6.apply(this, arguments);
                            };
                          }();
                          hideFunc = function hideFunc(_event) {
                            deleteButton.removeEventListener("click", deleteFunc, false);
                            fetchButton.removeEventListener("click", fetchFunc, false);
                            fetchButton.removeEventListener("click", cancelFunc, false);
                            modalElm.removeEventListener("hide.bs.modal", hideFunc, false);
                          };
                          modalElm.addEventListener("hide.bs.modal", hideFunc, false);
                          _context7.t0 = putTileCacheStats;
                          _context7.next = 25;
                          return ui.core.getMapTileCacheStatsAsync(from.mapID);
                        case 25:
                          _context7.t1 = _context7.sent;
                          (0, _context7.t0)(_context7.t1);
                          setTimeout(function () {
                            // eslint-disable-line no-undef
                            deleteButton.addEventListener("click", deleteFunc, false);
                            fetchButton.addEventListener("click", fetchFunc, false);
                            fetchButton.innerHTML = ui.core.t("html.cache_fetch");
                          }, 200);
                          _context7.next = 31;
                          break;
                        case 30:
                          cacheDiv.classList.add("hide");
                        case 31:
                          modal.show();
                          _context7.next = 35;
                          break;
                        case 34:
                          if (control === "help") {
                            ui.modalSetting("help");
                            modal.show();
                          } else if (control === "share") {
                            ui.modalSetting("share");
                            base = location.href; // eslint-disable-line no-undef
                            div1 = base.split("#!");
                            path = div1.length > 1 ? div1[1].split("?")[0] : "";
                            div2 = div1[0].split("?");
                            uri = div2[0];
                            query = div2.length > 1 ? div2[1].split("&").filter(function (qs) {
                              return qs !== "pwa";
                            }).join("&") : "";
                            if (query) uri = "".concat(uri, "?").concat(query);
                            view = uri;
                            if (path) view = "".concat(view, "#!").concat(path);
                            if (!qr_app) {
                              qr_app = new QRCode(ui.core.mapDivDocument.querySelector(".qr_app"), {
                                text: uri,
                                width: 128,
                                height: 128,
                                colorDark: "#000000",
                                colorLight: "#ffffff",
                                correctLevel: QRCode.CorrectLevel.H
                              });
                            } else {
                              qr_app.makeCode(uri);
                            }
                            if (!qr_view) {
                              qr_view = new QRCode(ui.core.mapDivDocument.querySelector(".qr_view"), {
                                text: view,
                                width: 128,
                                height: 128,
                                colorDark: "#000000",
                                colorLight: "#ffffff",
                                correctLevel: QRCode.CorrectLevel.H
                              });
                            } else {
                              qr_view.makeCode(view);
                            }
                            modal.show();
                          } else if (control === "border") {
                            flag = !ui.core.stateBuffer.showBorder;
                            ui.setShowBorder(flag);
                          } else if (control === "hideMarker") {
                            _flag = !ui.core.stateBuffer.hideMarker;
                            ui.setHideMarker(_flag);
                          } else if (control === "hideLayer") {
                            ui.modalSetting("hide_marker");
                            layers = ui.core.listPoiLayers(false, true);
                            elem = ui.core.mapDivDocument.querySelector("ul.list-group");
                            _modalElm = ui.core.mapDivDocument.querySelector(".modalBase");
                            elem.innerHTML = "";
                            layers.map(function (layer, index) {
                              var icon = layer.icon || pointer["defaultpin.png"];
                              var title = ui.core.translate(layer.name);
                              var check = !layer.hide;
                              var id = layer.namespaceID;
                              var newElems = createElement("<li c=\"list-group-item\"> <d c=\"row\"> <d c=\"col-sm-1\"><img c=\"markerlist\" src=\"".concat(icon, "\"></d> <d c=\"col-sm-9\">").concat(title, "</d> <d c=\"col-sm-2\"> <input type=\"checkbox\" c=\"markerlist\" data=\"").concat(id, "\" id=\"___maplat_marker_").concat(index, "_").concat(ui.html_id_seed, "\"").concat(check ? " checked" : "", "/> <label c=\"check\" for=\"___maplat_marker_").concat(index, "_").concat(ui.html_id_seed, "\"><d> </d> </label> </d> </d> </li>"));
                              for (var _i11 = 0; _i11 < newElems.length; _i11++) {
                                elem.appendChild(newElems[_i11]);
                              }
                              var checkbox = ui.core.mapDivDocument.querySelector("#___maplat_marker_".concat(index, "_").concat(ui.html_id_seed));
                              var checkFunc = function checkFunc(event) {
                                var id = event.target.getAttribute("data");
                                var checked = event.target.checked;
                                if (checked) ui.core.showPoiLayer(id);else ui.core.hidePoiLayer(id);
                              };
                              var hideFunc = function hideFunc(_event) {
                                _modalElm.removeEventListener("hide.bs.modal", hideFunc, false);
                                checkbox.removeEventListener("change", checkFunc, false);
                              };
                              _modalElm.addEventListener("hide.bs.modal", hideFunc, false);
                              checkbox.addEventListener("change", checkFunc, false);
                            });
                            modal.show();
                          }
                        case 35:
                        case "end":
                          return _context7.stop();
                      }
                    }, _callee7);
                  }));
                  return function (_x4) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                if (fakeGps) {
                  var newElem = createElement(sprintf(ui.core.t("app.fake_explanation"), ui.core.translate(fakeCenter), fakeRadius))[0];
                  var elem = ui.core.mapDivDocument.querySelector(".modal_gpsW_content");
                  elem.appendChild(newElem);
                } else {
                  var _newElem = createElement(ui.core.t("app.acquiring_gps_desc"))[0];
                  var _elem = ui.core.mapDivDocument.querySelector(".modal_gpsW_content");
                  _elem.appendChild(_newElem);
                }
                if (ui.waitReadyBridge) {
                  ui.waitReadyBridge();
                  delete ui.waitReadyBridge;
                }
              });
            case 43:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function initializer(_x) {
        return _initializer.apply(this, arguments);
      }
      return initializer;
    }() // Modal記述の動作を調整する関数
  }, {
    key: "modalSetting",
    value: function modalSetting(target) {
      var modalElm = this.core.mapDivDocument.querySelector(".modalBase");
      ["poi", "map", "load", "gpsW", "gpsD", "help", "share", "hide_marker"].map(function (target_) {
        var className = "modal_".concat(target_);
        if (target === target_) {
          modalElm.classList.add(className);
        } else {
          modalElm.classList.remove(className);
        }
      });
    }
  }, {
    key: "handleMarkerAction",
    value: function handleMarkerAction(data) {
      var _this2 = this;
      if (data.directgo) {
        var blank = false;
        var href = "";
        if (typeof data.directgo == "string") {
          href = data.directgo;
        } else {
          href = data.directgo.href;
          blank = data.directgo.blank || false;
        }
        if (blank) {
          window.open(href, "_blank"); // eslint-disable-line no-undef
        } else {
          window.location.href = href; // eslint-disable-line no-undef
        }
        return;
      }
      this.core.mapDivDocument.querySelector(".modal_title").innerText = this.core.translate(data.name);
      var modalElm = this.core.mapDivDocument.querySelector(".modalBase");
      if (data.url || data.html) {
        this.core.mapDivDocument.querySelector(".poi_web").classList.remove("hide");
        this.core.mapDivDocument.querySelector(".poi_data").classList.add("hide");
        var iframe = this.core.mapDivDocument.querySelector(".poi_iframe");
        if (data.html) {
          iframe.addEventListener("load", function loadEvent(event) {
            event.currentTarget.removeEventListener(event.type, loadEvent);
            var cssLink = createElement('<style type=\"text/css\">html, body { height: 100vh; } img { width: 100%; }</style>');
            var jsLink = createElement("<script> const heightGetter = document.querySelector(\"#heightGetter\"); const resizeObserver = new ResizeObserver(entries => { window.parent.postMessage([\"setHeight\", (entries[0].target.clientHeight + 16) + \"px\"], \"*\"); }); resizeObserver.observe(heightGetter); </script>");
            iframe.contentDocument.head.appendChild(cssLink[0]);
            iframe.contentDocument.head.appendChild(jsLink[0]);
          });
          iframe.removeAttribute("src");
          iframe.setAttribute("srcdoc", "<div id=\"heightGetter\">".concat(this.core.translate(data.html), "</div>"));
        } else {
          iframe.removeAttribute("srcdoc");
          iframe.setAttribute("src", this.core.translate(data.url));
        }
      } else {
        this.core.mapDivDocument.querySelector(".poi_data").classList.remove("hide");
        this.core.mapDivDocument.querySelector(".poi_web").classList.add("hide");
        var slides = [];
        if (data.image && data.image !== "") {
          var images = Array.isArray(data.image) ? data.image : [data.image];
          images.forEach(function (image) {
            if (typeof image === "string") {
              image = {
                src: image
              };
            }
            var tmpImg = _this2.resolveRelativeLink(image.src, "img");
            var slide = "<a target=\"_blank\" href=\"".concat(tmpImg, "\"><img src=\"").concat(tmpImg, "\"></a>");
            if (image.desc) slide = "".concat(slide, "<div>").concat(image.desc, "</div>");
            slides.push("<div class=\"swiper-slide\">".concat(slide, "</div>"));
          });
        } else if (!this.disableNoimage) {
          slides.push("<div class=\"swiper-slide\"><img src=\"".concat(pointer["no_image.png"], "\"></div>"));
        }
        var imgShowFunc = function imgShowFunc(_event) {
          modalElm.removeEventListener("shown.bs.modal", imgShowFunc, false);
          var swiperDiv = _this2.core.mapDivDocument.querySelector(".swiper-container.poi_img_swiper");
          if (slides.length === 0) {
            swiperDiv.classList.add("hide");
          } else {
            swiperDiv.classList.remove("hide");
            if (!_this2.poiSwiper) {
              _this2.poiSwiper = new Swiper(".swiper-container.poi_img_swiper", {
                lazy: true,
                modules: [Navigation, Pagination],
                pagination: {
                  el: ".poi-pagination",
                  clickable: true
                },
                navigation: {
                  nextEl: ".poi-img-next",
                  prevEl: ".poi-img-prev"
                }
              });
            }
            slides.forEach(function (slide) {
              return _this2.poiSwiper.appendSlide(slide);
            });
          }
        };
        modalElm.addEventListener("shown.bs.modal", imgShowFunc, false);
        this.core.mapDivDocument.querySelector(".poi_address").innerText = this.core.translate(data.address);
        this.core.mapDivDocument.querySelector(".poi_desc").innerHTML = this.core.translate(data.desc).replace(/\n/g, "<br>");
      }
      var modal = new bsn.Modal(modalElm, {
        root: this.core.mapDivDocument
      });
      this.core.selectMarker(data.namespaceID);
      var hideFunc = function hideFunc(_event) {
        modalElm.removeEventListener("hide.bs.modal", hideFunc, false);
        _this2.core.unselectMarker();
      };
      var hiddenFunc = function hiddenFunc(_event) {
        modalElm.removeEventListener("hidden.bs.modal", hiddenFunc, false);
        if (_this2.poiSwiper) {
          _this2.poiSwiper.removeAllSlides();
          _this2.poiSwiper = undefined;
        }
      };
      modalElm.addEventListener("hide.bs.modal", hideFunc, false);
      modalElm.addEventListener("hidden.bs.modal", hiddenFunc, false);
      this.modalSetting("poi");
      modal.show();
    }
  }, {
    key: "showFillEnvelope",
    value: function showFillEnvelope(mapIDs) {
      var ui = this;
      if (mapIDs.length > 0) {
        if (!ui._selectCandidateSources) ui._selectCandidateSources = {};
        Object.keys(ui._selectCandidateSources).forEach(function (key) {
          var index = mapIDs.indexOf(key);
          if (index < 0) {
            ui.core.mapObject.removeEnvelope(ui._selectCandidateSources[key]);
            delete ui._selectCandidateSources[key];
          } else mapIDs.splice(index, 1);
        });
        mapIDs.forEach(function (mapID) {
          if (mapID !== ui.core.from.mapID) {
            var source = ui.core.cacheHash[mapID];
            var xyPromises = source.envelope.geometry.coordinates[0].map(function (coord) {
              return ui.core.from.merc2SysCoordAsync(coord);
            });
            var hexColor = source.envelopeColor;
            var color = asArray(hexColor);
            color = color.slice();
            color[3] = 0.2;
            Promise.all(xyPromises).then(function (xys) {
              ui._selectCandidateSources[mapID] = ui.core.mapObject.setFillEnvelope(xys, null, {
                color: color
              });
            });
          }
        });
      } else {
        if (ui._selectCandidateSources) {
          Object.keys(ui._selectCandidateSources).forEach(function (key) {
            return ui.core.mapObject.removeEnvelope(ui._selectCandidateSources[key]);
          });
          delete ui._selectCandidateSources;
        }
      }
    }
  }, {
    key: "xyToMapIDs",
    value: function () {
      var _xyToMapIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(xy) {
        var threshold,
          ui,
          point_,
          map,
          size,
          extent,
          sysCoords,
          mercs,
          areaIndex,
          _args9 = arguments;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              threshold = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : 10;
              ui = this;
              point_ = point(xy);
              map = ui.core.mapObject;
              size = map.getSize();
              extent = [[0, 0], [size[0], 0], size, [0, size[1]], [0, 0]];
              sysCoords = extent.map(function (pixel) {
                return map.getCoordinateFromPixel(pixel);
              });
              _context9.next = 9;
              return ui.core.from instanceof NowMap || ui.core.from instanceof GoogleMap ? Promise.resolve(sysCoords) : Promise.all(sysCoords.map(function (sysCoord) {
                return ui.core.from.sysCoord2MercAsync(sysCoord);
              }));
            case 9:
              mercs = _context9.sent;
              areaIndex = ui.areaIndex(mercs);
              return _context9.abrupt("return", Promise.all(Object.keys(ui.core.cacheHash).filter(function (key) {
                return ui.core.cacheHash[key].envelope;
              }).map(function (key) {
                var source = ui.core.cacheHash[key];
                return Promise.all([Promise.resolve(source), Promise.all(source.envelope.geometry.coordinates[0].map(function (coord) {
                  return ui.core.from.merc2SysCoordAsync(coord);
                }))]);
              })).then(function (sources) {
                var mapIDs = sources.reduce(function (prev, curr) {
                  var source = curr[0];
                  var mercXys = curr[1];
                  if (source.mapID !== ui.core.from.mapID) {
                    var polygon_ = polygon([mercXys]);
                    if (booleanPointInPolygon(point_, polygon_)) {
                      prev.push(source);
                    }
                  }
                  return prev;
                }, []).filter(function (source) {
                  return source.envelopeAreaIndex / areaIndex < threshold;
                }).sort(function (a, b) {
                  return a.envelopeAreaIndex - b.envelopeAreaIndex;
                }).map(function (source) {
                  return source.mapID;
                });
                return mapIDs;
              }));
            case 12:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function xyToMapIDs(_x10) {
        return _xyToMapIDs.apply(this, arguments);
      }
      return xyToMapIDs;
    }()
  }, {
    key: "setShowBorder",
    value: function setShowBorder(flag) {
      this.core.requestUpdateState({
        showBorder: flag ? 1 : 0
      });
      this.updateEnvelope();
      if (flag) {
        this.core.mapDivDocument.classList.add("show-border");
      } else {
        this.core.mapDivDocument.classList.remove("show-border");
      }
      if (this.core.restoreSession) {
        var currentTime = Math.floor(new Date().getTime() / 1000);
        localStorage.setItem("epoch", currentTime); // eslint-disable-line no-undef
        localStorage.setItem("showBorder", flag ? 1 : 0); // eslint-disable-line no-undef
      }
    }
  }, {
    key: "setHideMarker",
    value: function setHideMarker(flag) {
      if (flag) {
        this.core.hideAllMarkers();
        this.core.mapDivDocument.classList.add("hide-marker");
      } else {
        this.core.showAllMarkers();
        this.core.mapDivDocument.classList.remove("hide-marker");
      }
    }
  }, {
    key: "updateEnvelope",
    value: function updateEnvelope() {
      var ui = this;
      if (!ui.core.mapObject) return;
      ui.core.mapObject.resetEnvelope();
      delete ui._selectCandidateSources;
      if (ui.core.stateBuffer.showBorder) {
        Object.keys(ui.core.cacheHash).filter(function (key) {
          return ui.core.cacheHash[key].envelope;
        }).map(function (key) {
          var source = ui.core.cacheHash[key];
          var xyPromises = key === ui.core.from.mapID && source instanceof HistMap ? [[0, 0], [source.width, 0], [source.width, source.height], [0, source.height], [0, 0]].map(function (xy) {
            return Promise.resolve(source.xy2SysCoord(xy));
          }) : source.envelope.geometry.coordinates[0].map(function (coord) {
            return ui.core.from.merc2SysCoordAsync(coord);
          });
          Promise.all(xyPromises).then(function (xys) {
            ui.core.mapObject.setEnvelope(xys, {
              color: source.envelopeColor,
              width: 2,
              lineDash: [6, 6]
            });
          });
        });
      }
    }
  }, {
    key: "resolveRelativeLink",
    value: function resolveRelativeLink(file, fallbackPath) {
      if (!fallbackPath) fallbackPath = ".";
      return file.match(/\//) ? file : "".concat(fallbackPath, "/").concat(file);
    }
  }, {
    key: "checkOverlayID",
    value: function checkOverlayID(mapID) {
      var ui = this;
      var swiper = ui.overlaySwiper;
      var sliders = swiper.$el[0].querySelectorAll(".swiper-slide");
      for (var i = 0; i < sliders.length; i++) {
        var slider = sliders[i];
        if (slider.getAttribute("data") === mapID) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "areaIndex",
    value: function areaIndex(xys) {
      return 0.5 * Math.abs([0, 1, 2, 3].reduce(function (prev, curr, i) {
        var xy1 = xys[i];
        var xy2 = xys[i + 1];
        return prev + (xy1[0] - xy2[0]) * (xy1[1] + xy2[1]);
      }, 0));
    }
  }, {
    key: "ellips",
    value: function ellips() {
      var ui = this;
      var omitMark = "…";
      var omitLine = 2;
      var stringSplit = function stringSplit(element) {
        var splitArr = element.innerText.split("");
        var joinString = "";
        for (var i = 0; i < splitArr.length; i++) {
          joinString += "<span>".concat(splitArr[i], "</span>");
        }
        joinString += "<span class=\"omit-mark\">".concat(omitMark, "</span>");
        element.innerHTML = joinString;
      };
      var omitCheck = function omitCheck(element) {
        var thisSpan = element.querySelectorAll("span");
        var omitSpan = element.querySelector(".omit-mark");
        var lineCount = 0;
        var omitCount;
        if (omitLine <= 0) {
          return;
        }
        thisSpan[0].style.display = "";
        for (var i = 1; i < thisSpan.length; i++) {
          thisSpan[i].style.display = "none";
        }
        omitSpan.style.display = "";
        var divHeight = element.offsetHeight;
        var minimizeFont = false;
        for (var _i12 = 1; _i12 < thisSpan.length - 1; _i12++) {
          thisSpan[_i12].style.display = "";
          if (element.offsetHeight > divHeight) {
            if (!minimizeFont) {
              minimizeFont = true;
              element.classList.add("minimize");
            } else {
              divHeight = element.offsetHeight;
              lineCount++;
            }
          }
          if (lineCount >= omitLine) {
            omitCount = _i12 - 2;
            break;
          }
          if (_i12 >= thisSpan.length - 2) {
            omitSpan.style.display = "none";
            return;
          }
        }
        for (var _i13 = omitCount; _i13 < thisSpan.length - 1; _i13++) {
          thisSpan[_i13].style.display = "none";
        }
      };
      var swiperItems = ui.core.mapDivDocument.querySelectorAll(".swiper-slide div");
      for (var i = 0; i < swiperItems.length; i++) {
        var swiperItem = swiperItems[i];
        stringSplit(swiperItem);
        omitCheck(swiperItem);
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      this.core.remove();
      delete this.core;
    }
  }]);
  return MaplatUi;
}(EventTarget);